import { useEffect, useState } from "react";

export const useMedia = (query: string) => {
    const getInitial = () =>
        typeof window !== "undefined" ? window?.matchMedia(query)?.matches : false;

    const [matches, setMatches] = useState<boolean>(getInitial);

    useEffect(() => {
        if (typeof window === "undefined") return;

        const mql = window.matchMedia(query);
        const handler = (e: MediaQueryListEvent) => setMatches(e.matches);

        // Modern browsers
        if (typeof mql?.addEventListener === "function") {
            mql?.addEventListener("change", handler);
            return () => mql?.removeEventListener("change", handler);
        }

        //legacy browsers
        mql?.addListener(handler);
        return () => mql?.removeListener(handler);
    }, [query]);

    return matches;
};
